import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "./../../../blocks/CarouselItem";
import MiniLegend from "./../../../items/MiniLegend";
import Source from "./../../../items/Source";


import {LinePlot} from "d3plus-react";

import {removeDecimalsIfNotNeeded} from "./../../../../helpers/formatters";


class EUWideEmpRates extends Component {

  constructor(props) {
    super(props);
    // we should move this data to a separate file outside the build
    let data = [
        {empRate: .651, kind: "2011 - 20", year: 2011},
        {empRate: .651, kind: "2011 - 20", year: 2012},
        {empRate: .649, kind: "2011 - 20", year: 2013},
        {empRate: .656, kind: "2011 - 20", year: 2014},
        {empRate: .665, kind: "2011 - 20", year: 2015},
        {empRate: .675, kind: "2011 - 20", year: 2016},
        {empRate: .686, kind: "2011 - 20", year: 2017},
        {empRate: .698, kind: "2011 - 20", year: 2018},
        {empRate: .707, kind: "2011 - 20", year: 2019},
        {empRate: .710, kind: "2011 - 20", year: 2020},
        {empRate: .710, kind: "2020 - 30", year: 2020},
        {empRate: .714, kind: "2020 - 30", year: 2021},
        {empRate: .718, kind: "2020 - 30", year: 2022},
        {empRate: .722, kind: "2020 - 30", year: 2023},
        {empRate: .725, kind: "2020 - 30", year: 2024},
        {empRate: .729, kind: "2020 - 30", year: 2025},
        {empRate: .733, kind: "2020 - 30", year: 2026},
        {empRate: .737, kind: "2020 - 30", year: 2027},
        {empRate: .741, kind: "2020 - 30", year: 2028},
        {empRate: .744, kind: "2020 - 30", year: 2029},
        {empRate: .748, kind: "2020 - 30", year: 2030},
    ];

    const config = {
        data,
        height: 310,
        groupBy: "kind",
        x: "year",
        discrete: "x",
        y: "empRate",
        legend: false,
        tooltipConfig: {
            body: d => `<div>Employment rate, % ${d.year}: ${removeDecimalsIfNotNeeded(d.empRate * 100)}%</div>`
        },
        annotations: [
            // TODO
        ],
        xConfig: {
          gridConfig: {
            "stroke": "rgb(164, 164, 164)",
            "stroke-width": d => {
              return d.id === 2020 ? 1 : 0;
            },
          },
          barConfig: {
            stroke: "rgb(164, 164, 164)",
            "stroke-width": 1
          }
        },
        yConfig: {
            tickFormat: tick => `${removeDecimalsIfNotNeeded(tick * 100)}`,
            title: "Employment rate, % 2011-30",
            gridConfig: {
              "stroke": "rgb(164, 164, 164)",
              "stroke-width": 1
            },
            barConfig: {
              stroke: "rgb(164, 164, 164)",
              "stroke-width": 1
            }
        },
        shapeConfig: {
          Line: {
            stroke: function(d) {
              return d.kind !== "2020 - 30" ? "rgb(0, 21, 34)" : "rgb(43, 173, 240)";
            },
            strokeWidth: 2.5
          }
        }
      }
      this.state = {
        config,
        colors: [
          {color: "rgb(0, 21, 34)", label: "2011 - 20"},
          {color: "rgb(43, 173, 240)", label: "2020 - 30"}
        ]
      };
  }

  render() {
    const {colors, config} = this.state;

    return (
      <CarouselItem title="Rising employment rates" subtitle={<>Europe&rsquo;s employment rate has been rising steadily since 2014 — and that trend needs to continue to fill the jobs of the future<sup>1</sup></>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <LinePlot config={config} />
          <Source text="1.- Linear projection of estimated employment in 2030." />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis." />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EUWideEmpRates);
